"use client";

import { useEffect } from "react";
import { useNullableUserContext } from "@/app/_hooks/useUserContext";
import { trackStripeVerified } from "@/app/_utils/marketingConversions";

// stripe_verified is MountMonitor subscription started: Stripe Checkout
// fulfillment writes users/{uid}.signup.status = "complete" after an
// active/trialing Atlas subscription exists. That is the durable client
// signal (not Connect charges_enabled, which is optional payments onboarding).
//
// A new subscriber is complete but not yet onboarded, whichever page they come
// back through: Stripe's return page, a fresh login after Checkout lost the
// session, or another device. Don't key this on the return URL. Once-only per
// uid per browser; Google Ads dedupes across browsers on transaction_id.
export default function MarketingConversionTracker() {
  const user = useNullableUserContext();
  const uid = user?.uid;
  const status = user?.signup?.status;
  const onboarded = user?.onboarded;
  const plan = user?.signup?.plan;
  const interval = user?.signup?.interval;

  useEffect(() => {
    if (uid && status === "complete" && !onboarded) {
      trackStripeVerified(uid, { plan, interval });
    }
  }, [uid, status, onboarded, plan, interval]);

  return null;
}
